module.exports = __webpack_public_path__ + "img/logo-text_argo.cde7b270.svg";